<template>
  <div aria-live="assertive" class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:items-start sm:p-6">
    <div
      class="absolute z-50 flex flex-col items-center w-full space-y-4 sm:h-full sm:items-end"
      :class="{
        'sm:items-start': $store.state.ui.notificationInfo?.xPosition == 'left',
        'sm:items-center': $store.state.ui.notificationInfo?.xPosition == 'center',
        'sm:justify-start': $store.state.ui.notificationInfo?.yPosition == 'top',
        'sm:justify-center': $store.state.ui.notificationInfo?.yPosition == 'center',
        'sm:justify-end': $store.state.ui.notificationInfo?.yPosition == 'bottom'
      }">
      <transition
        enter-active-class="transition duration-500 ease-in transform"
        :enter-from-class="
          $store.state.ui.notificationInfo?.yPosition == 'top'
            ? '-translate-y-2 opacity-0 -sm:translate-y-2 sm:translate-x-0'
            : 'translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2'
        "
        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
        leave-active-class="transition duration-300 ease-out transform"
        :leave-to-class="
          $store.state.ui.notificationInfo?.yPosition == 'top'
            ? '-translate-y-2 opacity-0 -sm:translate-y-2 sm:translate-x-0'
            : 'translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2'
        ">
        <div
          v-if="$store.state.ui.showNotificationInfo"
          class="w-full max-w-sm overflow-hidden bg-white rounded-lg shadow-lg pointer-events-auto ring-1 ring-black ring-opacity-5">
          <div class="p-4">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <Info v-if="$store.state.ui.notificationInfo.type == 'information'" class="w-8 h-8 text-blue-light" aria-hidden="true" />
                <CircleAlert v-if="$store.state.ui.notificationInfo.type == 'warning'" class="w-8 h-8 text-yellow-400" aria-hidden="true" />
                <CircleX v-if="$store.state.ui.notificationInfo.type == 'error'" class="w-8 h-8 text-red-500" aria-hidden="true" />
                <CircleCheck v-if="$store.state.ui.notificationInfo.type == 'success'" class="w-8 h-8 text-green-500" aria-hidden="true" />
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="font-medium text-gray-900 text-md">
                  {{ $store.state.ui.notificationInfo.title }}
                </p>
                <p class="mt-1 text-sm text-gray-500">
                  {{ $store.state.ui.notificationInfo.description }}
                </p>
              </div>
              <div class="flex flex-shrink-0 ml-4">
                <button
                  type="button"
                  class="inline-flex text-gray-400 bg-white rounded-md hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue focus:ring-offset-2"
                  @click="$store.dispatch('ui/hideNotification')">
                  <span class="sr-only">{{ $t("Close") }}</span>
                  <X class="w-5 h-5" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { X, CircleCheck, Info, CircleAlert, CircleX } from "lucide-vue-next"
export default {
  components: {
    CircleCheck,
    Info,
    CircleAlert,
    CircleX,
    X
  }
}
</script>
